import type { ReactNode } from 'react'

// react-markdown >= 9 no longer passes an `inline` prop to the `code`
// component. Fenced/indented blocks are the ones wrapped in <pre>: they carry a
// `language-*` class when a language is given, and their text always ends with
// a newline (inline code spans never contain one).
export const isBlockCode = (className: string | undefined, children: ReactNode): boolean => {
  if (className && /(^|\s)language-/.test(className)) return true
  const text = Array.isArray(children) ? children.join('') : String(children ?? '')
  return text.includes('\n')
}
